import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  getUserFullName,
  getUserListItemContentName,
} from '../../../utils/user'
import { SearchItem } from '../../Search'
import { UserStatusTag } from '../UserStatusTag'

import * as styles from './UserSearchItem.module.css'

function UserSearchItem({ className = styles.UserSearchItem, value }) {
  const {
    address,
    archived,
    avatar,
    avatar_color: avatarColor,
    email,
    is_landlord,
    phone,
    status,
  } = value.item ?? EMPTY_OBJECT

  const { t } = useTranslation()

  const fullname = getUserFullName(value.item)

  const additional = [
    <UserStatusTag key='status' value={status} />,
    address,
    email,
    phone,
  ]

  const icon = { color: avatarColor, src: avatar, text: fullname }

  const title = [
    getUserListItemContentName(email, fullname),
    is_landlord ? t('UserSearch.LandlordKey') : t('UserSearch.TenantKey'),
  ].join(' | ')

  return (
    <SearchItem
      additional={additional}
      archived={archived}
      className={className}
      icon={icon}
      title={title}
    />
  )
}

export default UserSearchItem
